import ResponseBaseModel from '../../ResponseBaseModel'

export default class CACA1030ResponseModel extends ResponseBaseModel {
  hikakuProductLst: [
    {
      productNameInformal: string
      monthlyChartLst: [
        {
          monthlyChartBaseDate: string
          monthlyChartValue: string
        }
      ]
    }
  ]
}
